import React, { Component } from "react";
import SharedViewProps from "../../../../../models/types/SharedViewProps";
import PaginatedDialogView from "../../components/PaginatedDialog/PaginatedDialogView";
import { Elements } from "react-stripe-elements";
import PaymentFormView from './components/PaymentForm/PaymentFormView';

export default class PaymentView extends Component<SharedViewProps> {

    private _onPaymentCompleted = () => {
        this.props.routeProps.history.push('confirmation');
    }

    render() {
        // TODO: Determine if the check amount is constant or can vary
        return (
            <PaginatedDialogView title='oneShotCheckRequest' subtitle='onlinePayment'>
                <Elements>
                    <PaymentFormView routeProps={this.props.routeProps} amount={150} onPaymentCompleted={this._onPaymentCompleted} />
                </Elements>
            </PaginatedDialogView>
        );
    }
}